import container from "@/lib/di/container";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { FilterBar, FilterInputTemplate, FilterInputType } from "../../components/filter/FilterBar";
import { FilterSearchPayload, DataTable } from "../../components/table/DataTable";
import { DetailModal } from "./modals/DetailModal";
import { Button, Dropdown, message, Modal, Popconfirm, QRCode, Tooltip } from "antd";
import { CloseOutlined, InfoCircleOutlined, MoreOutlined, QrcodeOutlined } from "@ant-design/icons";
import { formatDateTimePipe } from "@/core/pipes/format-date.pipe";
import { TopUpTransactionModel, TopUpTransactionModelFactory } from "@/core/models/top-up-transaction.model";
import { TopUpTransactionRepo } from "@/core/repos/tables/top-up-transaction.repo";
import { invoiceStatusPipe } from "@/core/pipes/invoice-status.pipe";
import { useTitleDataStore } from "@/core/stores/title-data.store";
import { formatCurrencyPipe } from "@/core/pipes/format-currency.pipe";

const topUpTransactionRepo = container.get(TopUpTransactionRepo);

interface QRModalProps {
    isModalOpen: boolean,
    setIsModalOpen: Dispatch<SetStateAction<boolean>>,
    qrData: string,
    record: TopUpTransactionModel
}
const QRModal: React.FC<QRModalProps> = ({isModalOpen, setIsModalOpen, qrData, record}) => {
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    return <Modal open={isModalOpen} onCancel={handleCancel} width={500} footer={[]} centered
        styles={{
            mask: {
                backdropFilter: 'blur(2px)',
                backgroundColor: 'var(--primary-mask)'
            }
        }}
    >
        <div className="flex flex-col justify-center items-center">
            <div className="flex flex-row w-full items-start justify-start select-none">
                <p className="ml-6 text-2xl font-bold text-primary">QR THANH TOÁN</p>
            </div>
            <div className="mt-3 mb-3">
                <QRCode value={qrData} size={420} />
            </div>
        </div>
    </Modal>
} 

export default function TopupTransactionPage() {
    const titleData = useTitleDataStore();
    const [modalData, setModalData] = useState<TopUpTransactionModel>(TopUpTransactionModelFactory.getEmpty())
    const [filterMap, setFilterMap] = useState<Map<string, FilterSearchPayload>>(new Map())
    const [selectedRows, setSelectedRows] = useState<TopUpTransactionModel[]>([]);
    const [isDetailModal, setDetailModal] = useState(false);
    const [isQrModal, setQrModal] = useState(false);
    const [qrData, setQrData] = useState<string>("");
    const [deleting, setDeleting] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [filterTemplates] = useState<FilterInputTemplate[]>([
        {
            dataIndex: "search",
            label: "Tên người thụ hưởng",
            placeholder: "Nhập tên thụ hưởng",
            type: FilterInputType.text,
        },
    ])

    const showDetail = (record: TopUpTransactionModel) => {
        setModalData(record);
        setDetailModal(true);
    };


    const showQR = async (record: TopUpTransactionModel) => {
        const qrData = await topUpTransactionRepo.getQR(record);
        setQrData(qrData);
        setModalData(record);
        setQrModal(true);
    }

    const init = async () => {
        titleData.setTitleActions({
            text: "Thêm Phiếu thu tiền",
            onPress: () => {
                showDetail(TopUpTransactionModelFactory.getEmpty())
            }
        })
    }

    useEffect(()=>{init()}, []);

    const cancelSelected = async () => {
        setDeleting(true);
        const result = await topUpTransactionRepo.cancelMany(selectedRows);
        messageApi.success({
            content: `Bạn đã huỷ thành công ${result.success}/${result.total} giao dịch đã chọn`
        })
        setDeleting(false);
    }


    async function onFilterChange(map: Map<string, FilterSearchPayload>) {
        setFilterMap(new Map(map));
    }

    function onRowSelect(rows: TopUpTransactionModel[]) {
        setSelectedRows([...rows]);
    }

    return (
    <div className="px-4 py-6">

        
        {contextHolder}
        <FilterBar setMap={setFilterMap} onChange={onFilterChange} templates={filterTemplates} map={filterMap} actions={[
            <div key={1} className="mt-6">
                <Popconfirm
                    title={`Huỷ ${selectedRows.length} giao dịch?`}
                    description={`Bạn có chắc chắn muốn huỷ ${selectedRows.length} giao dịch đã chọn?`}
                    onConfirm={cancelSelected}
                    okText="Huỷ giao dịch"
                    cancelText="Không huỷ"
                >
                    <Button className='ml-2' loading={deleting} type="primary" danger icon={<CloseOutlined />} disabled={selectedRows.length === 0}>Huỷ giao dịch</Button>
                </Popconfirm>
            </div>
        ]}/>
        <div className="mt-4 border-t border-dashed border-gray-300 pt-6">
            <DataTable<TopUpTransactionModel>
                columns={[
                    { dataIndex: 'remitterName', name: 'Người nộp tiền' },
                    { dataIndex: 'amount', name: 'Số tiền giao dịch', pipe: formatCurrencyPipe },
                    { dataIndex: 'createdAt', name: 'Thời gian giao dịch', pipe: formatDateTimePipe },
                    { dataIndex: 'createdBy', name: 'Người tạo' },
                    { dataIndex: 'code', name: 'Mã giao dịch' },
                    { dataIndex: 'status', name: 'Trạng thái giao dịch', pipe: invoiceStatusPipe},
                    { dataIndex: 'completeDate', name: 'Thời gian hoàn thành', pipe: formatDateTimePipe },
                    { dataIndex: 'information', name: 'Thông tin giao dịch' },
                    {
                        name: 'Thao tác',
                        render: (_, record) => (
                                <div className="flex flex-row px-1 items-center justify-center">
                                    <Tooltip title="Xem phiếu thu tiền"><Button type="text" icon={<InfoCircleOutlined />} onClick={() => showDetail(record)}/></Tooltip>
                                    <Dropdown menu={{items: [
                                        {
                                            key: '1',
                                            label: <p>Tạo mã QR thanh toán</p>,
                                            icon: <QrcodeOutlined />,
                                            onClick: () => showQR(record)
                                        },
                                    ]}} trigger={["hover"]}>
                                        <Button type="text" icon={<MoreOutlined />}/>
                                    </Dropdown>
                                    
                                </div>
                            ),
                        fixed: "right"
                    },
                ]}
                repository={topUpTransactionRepo}
                filterMap={filterMap}
                onSelect={onRowSelect}
            ></DataTable>
        </div>
        <DetailModal isModalOpen={isDetailModal} setIsModalOpen={setDetailModal} data={modalData}></DetailModal>
        <QRModal isModalOpen={isQrModal} setIsModalOpen={setQrModal} qrData={qrData} record={modalData}></QRModal>
    </div>)
}